import {useState} from 'react'
import {useNavigate} from 'react-router'
import {ActionPanel} from 'brand/ActionPanel'
import {Button} from 'brand/Button'

import camera from './icon-camera.svg'
import info from './icon-info.svg'
import lock from './icon-lock.svg'
import reticule from './illustration-reticule.svg'

const disclosures = [
  {icon: info, alt: 'Info icon', text: 'Some tips for getting the best results'},
  {icon: lock, alt: 'Lock icon', text: "Your photo won't leave this device"},
]

export const SelfieIntro = ({chooseCannedPhoto}) => {
  const nav = useNavigate()
  const [showTips, setShowTips] = useState(false)

  const continueWithCannedPhoto = () => {
    chooseCannedPhoto()
    nav('/consult/questionnaire')
  }

  return (
    <>
      <div className="fullscreen-bg selfie-intro">
        <div className="column align-bottom">
          <section className="column align-center" style={{flexGrow: 1}}>
            <section className="page-title">
              <div className="heading size-s">Photo upload</div>
            </section>
            <div className="heading size-xxxl">Let's get to know you...</div>
            <div className="content">
              <Button tone="highlight" action={() => nav('/consult/selfie/camera')}>
                <img src={camera} alt="Camera icon" /> Take a photo
              </Button>
              <Button tone="lowlight" action={continueWithCannedPhoto}>
                or Choose an existing photo
              </Button>
            </div>
          </section>
          <section>
            <div className="content">
              {disclosures.map(({icon, alt, text}) => (
                <div className="photo-disclosure" key={text}>
                  <img src={icon} alt={alt} />
                  <span className="size-ml">{text}</span>
                </div>
              ))}
            </div>
            <div className="content">
              <Button size="large" action={() => setShowTips(true)}>Photo tips</Button>
            </div>
          </section>
        </div>
      </div>
      <ActionPanel title="Photo tips" show={showTips} onClose={() => setShowTips(false)}>
        <div className="inline-column content">
          <img src={reticule} alt="Reticule illustation" />
          <div className="title size-m">Centred and front-on</div>
          <div className="detail size-m">Take your photo as centred and straight-on as possible.</div>
        </div>
      </ActionPanel>
    </>
  )
}
